export const sleep = (durationInMiliseconds: number) =>
  new Promise((resolve) => setTimeout(resolve, durationInMiliseconds));
